import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../styles';
import { translate } from '../translate';

export const ProductInfo = ({ info }) => (
  <View>
    {info ? (
      <>
        <Text style={[styles.bold, styles.black]}>
          {translate('headers.idea')}
        </Text>
        <Text style={styles.productInfo}>{info}</Text>
      </>
    ) : null}
  </View>
);
